import moment from 'moment';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classnames from 'classnames';
import React, {Component} from 'react';

import AddFilter from './AddFilter';
import * as ObjectConst from '../../constants/Property';
import {updateField} from '../../actions/CreatingObjectPage';

const propTypes = {
    isActive: PropTypes.bool.isRequired
};

const defaultProps = {
    updateField: (objectId, updateFieldCommand) => {
    }
};

class Characteristics extends Component {
    state = {
        POOL: '',
        FLOOR: '',
        GARAGE: '',
        GARDEN: '',
        LIFESTYLE: '',
        YEAR_OF_CONSTRUCTION: '',
        isYearOfConstructionValid: false
    };

    componentWillReceiveProps(nextProps) {
        const {
            creatingObjectPage: {
                createdObject: {
                    id,
                    characteristics: {
                        pool,
                        floor,
                        garage,
                        garden,
                        lifestyle,
                        yearOfConstruction
                    }
                }
            }
        } = nextProps;

        if (id !== undefined) {
            this.setState({
                POOL: pool,
                FLOOR: floor,
                GARAGE: garage,
                GARDEN: garden,
                LIFESTYLE: lifestyle,
                YEAR_OF_CONSTRUCTION: yearOfConstruction === 0 ? '' : yearOfConstruction,
            });
        }
    }

    updateField = event => {
        const field = event.currentTarget.name;
        const value = event.currentTarget.value;
        const {creatingObjectPage: {createdObject: {id}}} = this.props;
        const updateFieldCommand = {
            name: field
        };

        switch (field) {
            case ObjectConst.FIELDS.YEAR_OF_CONSTRUCTION:
                if (value.length === 4) {
                    updateFieldCommand.value = value;
                } else {
                    updateFieldCommand.value = 0;
                    this.setState({
                        YEAR_OF_CONSTRUCTION: ''
                    });
                }
                break;
            default:
                updateFieldCommand.value = value;
                break;
        }
        this.props.updateField(id, updateFieldCommand);
    };

    handleChange = event => {
        const field = event.currentTarget.name;
        const value = event.currentTarget.value;

        switch (field) {
            case
            ObjectConst.FIELDS.YEAR_OF_CONSTRUCTION:
                if (
                    value.length === 0 ||
                    (
                        value.length < 4 &&
                        Number.isInteger(parseInt(value.substr(-1), 10))
                    ) ||
                    (
                        value.length === 4 &&
                        Number.isInteger(parseInt(value.substr(-1), 10)) &&
                        parseInt(value, 10) > 1900 &&
                        parseInt(value, 10) <= moment().format('YYYY')
                    )
                ) {
                    const newState = {};
                    newState[field] = value;

                    this.setState(newState);
                }
                break;
            default:
                const newState = {};
                newState[field] = value;

                this.setState(newState);
        }
    };

    render() {
        const {
            i18n,
            configuration: {
                object: {
                    poolValues,
                    lifestyles,
                    floorValues,
                    garageValues,
                    gardenValues
                }
            }
        } = this.props;
        const {LIFESTYLE, POOL, FLOOR, GARAGE, GARDEN, YEAR_OF_CONSTRUCTION} = this.state;

        return (
            <div className={
                this.props.isActive ? 'clearfix tab_content animated show active' : 'clearfix tab_content animated show'
            }>
                <div className="heading">
                    <h3>
                        {i18n['creatingObjectPage.characteristics']}
                    </h3>
                </div>

                <div className="clearfix mt30">
                    <label>
                        <span className="info">
                            <i className="fa fa-question-circle" />
                            <span>{i18n['creatingObjectPage.characteristics.hint1']}</span>
                        </span>
                        {i18n['creatingObjectPage.characteristics.lifestyle']}:
                        <select
                            value={LIFESTYLE}
                            onBlur={this.updateField}
                            onChange={this.handleChange}
                            name={ObjectConst.FIELDS.LIFESTYLE}
                        >
                            {lifestyles.map(elem => <option key={elem.value} value={elem.value}>{elem.title}</option>)}
                        </select>
                    </label>

                    <div className="grid grid-width-1-3">
                        <div>
                            <label>
                                <span className="info">
                                    <i className="fa fa-question-circle" />
                                    <span>
                                        {i18n['creatingObjectPage.characteristics.hint2']}
                                    </span>
                                </span>
                                Бассейн:
                                <select
                                    value={POOL}
                                    onBlur={this.updateField}
                                    onChange={this.handleChange}
                                    name={ObjectConst.FIELDS.POOL}
                                >
                                    {poolValues.map(
                                        elem => <option key={elem.value} value={elem.value}>{elem.title}</option>
                                    )}
                                </select>
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="info">
                                    <i className="fa fa-question-circle" />
                                    <span>
                                        {i18n['creatingObjectPage.characteristics.hint3']}
                                    </span>
                                </span>
                                Гараж:
                                <select
                                    value={GARAGE}
                                    onBlur={this.updateField}
                                    onChange={this.handleChange}
                                    name={ObjectConst.FIELDS.GARAGE}
                                >
                                    {garageValues.map(
                                        elem => <option key={elem.value} value={elem.value}>{elem.title}</option>
                                    )}
                                </select>
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="info">
                                    <i className="fa fa-question-circle" />
                                    <span>
                                        {i18n['creatingObjectPage.characteristics.hint4']}
                                    </span>
                                </span>
                                Сад:
                                <select
                                    value={GARDEN}
                                    onBlur={this.updateField}
                                    onChange={this.handleChange}
                                    name={ObjectConst.FIELDS.GARDEN}
                                >
                                    {gardenValues.map(
                                        elem => <option key={elem.value} value={elem.value}>{elem.title}</option>
                                    )}
                                </select>
                            </label>
                        </div>
                    </div>

                    <div className="grid grid-width-1-3">
                        <div>
                            <label>
                                <span className="info">
                                    <i className="fa fa-question-circle" />
                                    <span>
                                        {i18n['creatingObjectPage.characteristics.hint5']}
                                    </span>
                                </span>
                                Этаж:
                                <select
                                    value={FLOOR}
                                    onBlur={this.updateField}
                                    onChange={this.handleChange}
                                    name={ObjectConst.FIELDS.FLOOR}
                                >
                                    {floorValues.map(
                                        elem => <option key={elem.value} value={elem.value}>{elem.title}</option>
                                    )}
                                </select>
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="info">
                                    <i className="fa fa-question-circle" />
                                    <span>
                                        {i18n['creatingObjectPage.characteristics.hint6']}
                                    </span>
                                </span>
                                Год постройки:
                                <input
                                    onBlur={this.updateField}
                                    value={YEAR_OF_CONSTRUCTION}
                                    onChange={this.handleChange}
                                    name={ObjectConst.FIELDS.YEAR_OF_CONSTRUCTION}
                                    placeholder={`Укажите год в диапазоне: 1900 - ${moment().format('YYYY')}`}
                                    className={classnames({
                                        'invalid':  YEAR_OF_CONSTRUCTION == undefined || YEAR_OF_CONSTRUCTION.length === 0
                                    })}
                                />
                            </label>
                        </div>
                    </div>

                    <AddFilter disabled={true} />
                </div>
            </div>
        )
    }
}

Characteristics.propTypes = propTypes;
Characteristics.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    configuration: state.configuration,
    creatingObjectPage: state.creatingObjectPage
});

const mapDispatchToProps = {
    updateField
};

export default connect(mapStateToProps, mapDispatchToProps)(Characteristics);



// WEBPACK FOOTER //
// ./src/components/CreatingProperty/Characteristics.js